<div class="bar-holder" [ngClass]="{ hidden: !showBarChart }">
  <div class="close" (click)="showBarChart=false">X</div>
  <svg id="eventChart"  width="800" height="490"></svg>
</div>
<nav *ngIf="{ homeUrl: '/home/' + (this.settings?.homepage === 'card' ? this.settings?.homepage || '' : '') } as vars">  
  <div class="logo" [ngClass]="{ hide: show_event_title }"><a class="hyper-div" [routerLink]="hide_home_button ? null : vars.homeUrl" (click)="hide_home_button ? null : goHome($event)"><icon class="joi-icon" icon="joi_logo_white"></icon></a></div>
  <div class="functions">
      <div class="left">
        <a class="hyper-div" *ngIf="mobileView && !hide_home_button" [routerLink]="vars.homeUrl" (click)="goHome($event)"><icon *ngIf="!hide_home_button" class="home_logo"  icon="home_24px"></icon></a>
        <menu-hover-button *ngIf="!hide_home_button && !mobileView" class="hyper-div home" [customTransform]="'translateY(-100px)'" [iconSelector]="'home_24px'" [noBackground]="true" [noWrap]="false" [routerLink]="vars.homeUrl" (buttonClick)="goHome($event)">
          <div class="hover-menu smooth">
            <div class="inner-menu">
              <button mat-menu-item (click)="goTo(vars.homeUrl)">
                <span>Events</span>
              </button>
              <button mat-menu-item (click)="goTo('/tasks/')">
                <span>Tasks</span>
              </button>
              <button mat-menu-item (click)="goTo('/event-lists/')">
                <span>Publish</span>
              </button>
              <button mat-menu-item (click)="goTo('/clipboard/')">
                <span>Clipboard</span>
              </button>
              <button mat-menu-item (click)="goTo('/budget/')">
                <span>Budget</span>
              </button>
            </div>
          </div>
        </menu-hover-button>

        <div class="in_event event_title_container" [ngClass]="{show:show_event_title}">
          <event-status *ngIf="!mobileView" [dotOnly]="false"></event-status>
          <event-status *ngIf="mobileView" [dotOnly]="true"></event-status>
          <h1 *ngIf="!mobileView" class="event_title">{{ event?.title }}</h1>
          <h1 *ngIf="!mobileView && event?.closed" class="is_closed">(Closed)</h1>
          <h1 *ngIf="!mobileView && account?.docket?.status === 'suspended'" class="is_closed">(Suspended)</h1>
          <div *ngIf="mobileView" class="title-date ellipsis">
            <div>{{ event?.title }}</div>
            <div *ngIf="event?.dates_string?.length">{{ eventDateString }}</div>
          </div>
        </div>
        <div *ngIf="!mobileView && event?.dates_string?.length" class="date_string">{{ eventDateString }}</div>
      </div>
      <div class="right">
          <div class="message-holder" (click)="openMessages()" *ngIf="!!show_event_title">
            <icon [icon]="'chat'"></icon>
            <div *ngIf="!!hasNewMessages" class="chat_dot"></div>
          </div>
          
          <div *ngIf="event && !event.closed && !event.can_access" style="margin-left: 10px;">
              <button mat-button color="primary" [disabled]="account?.docket?.status === 'suspended'" (click)="eventService.grantWorkforcePrivileges(event)">Join workforce</button>
          </div>
          <div *ngIf="!mobileView && trialDaysRemaining.days_remaining < 31" class="nav_item days_remaining">
              <b>Free trial:</b> {{ trialDaysRemaining.days_remaining  }} day{{ trialDaysRemaining.days_remaining === 1 ? '' : 's'}} remaining. &nbsp;
              <span (click)="subscribeNow(trialDaysRemaining.id)" class="text_link">Subscribe Now</span>
          </div>
          <!-- <ng-container [ngTemplateOutlet]="progress" [ngTemplateOutletContext]="{ main: true }"></ng-container> -->
          <div *ngIf="!mobileView && loggedIn" class="photo" (click)="showMenu = !showMenu">
              <photo [data]="user" [size]="36"></photo>
          </div>
          <icon *ngIf="mobileView && userService.uid" class="menu_btn" (click)="clickMobileHamburger()" [icon]="(showMenu || forceShowMobile ? 'close' : 'hamburger')"></icon>
      </div>
  </div>
</nav>
<div class="message_container" 
*ngIf="!is_accounts_page"
[ngStyle]="{zIndex:messagesZindex ? messagesZindex + 10 : 10001}"
[ngClass]="{with_popup:with_popup}"
>
  <div
  *ngFor="let message of messages; index as i"
  [class]="(message.class ? message.class : '') + ' messages'"
  [ngClass]="{error:message.type === 'error'}"
  [@drop]="messages.length == 0 ? 'collapse' : 'expand'">
    <div class="message">
      <div class="text" (click)="messageClicked(i)">
        <icon *ngIf="message.icon == 'error'" class="joi-icon error-icon" icon="error_80px"></icon>
        <icon *ngIf="message.icon == 'warn'" matIcon="warning"></icon>
        <div *ngIf="message.icon == 'problem'" class="problem"><icon matIcon="report_problem"></icon></div>
        <div class="message_text">
          {{message.message}}
        </div>
        <div *ngIf="message.action == 'critical'" class="refresh" (click)="messageClicked(i)">
            &nbsp;
            <span *ngIf="!message.button_text">Please <u>refresh</u> to continue.</span>
            <span *ngIf="message.button_text">{{message.button_text}}</span>
        </div>
        <div *ngIf="message.action == 'account'">
          <button mat-button color="primary" (click)="closeMessage(i, true)"  >{{ message.button_text}}</button>
        </div>
      </div>
      <icon class="close" *ngIf="message.action != 'critical'" (click)="closeMessage(i)" matIcon="close"></icon></div>
  </div>
</div>
<div class="menu-panel-cloud"  (click)="closeMobileMenu($event)" [ngClass]="{ 
  show: showMenu, mobileShow: forceShowMobile }">
  <div class="nav_menu">
      <div id="pointer"></div>
      <div class="nav_content">
          <div class="user" [ngClass]="{collapsible: show_event_title}" (click)="mobile_menu_nav = !mobile_menu_nav">
              <icon class="expand_arrow" [matIcon]="(mobile_menu_nav ? 'arrow_right' : 'arrow_drop_down' )"></icon>
              <photo [data]="user" [size]="36"></photo>
              <div class="name">
                  <h4 class="ellipsis">{{user?.firstName + ' ' + user?.lastName}}</h4>
                  <div class="email ellipsis">{{user?.email}}</div>
              </div>
          </div>
          <div class="user_content" [ngClass]="{collapse: mobile_menu_nav}">
              <div class="group">
                  <a [routerLink]="'/accounts/'" (click)="closeMobileMenu($event)">Accounts</a>
                  <a (click)="openProfile()">Profile</a>
                  <a [routerLink]="'notification-settings'" (click)="closeMobileMenu($event)">Notification Settings</a>
              </div>
              <div class="group">
                  <h5>Help</h5>
                  <!-- <a href="https://www.joi.events/quickstart-guide" target="_blank">Quickstart guide</a>
                  <a href="https://www.joi.events/faq" target="_blank">FAQ</a> -->
                  <a href="https://www.joi.events/contact" target="_blank">Contact us</a>
                  <a href="https://www.joi.events/feedback" target="_blank">Feedback</a>
              </div>
              <div class="group">
                  <h5>Connect</h5>
                  <div class="links">
                      <a href="https://www.facebook.com/joiepm" target="_blank"><icon icon="social_facebook_24px"></icon></a>
                      <a href="https://www.instagram.com/joi.events" target="_blank"><icon icon="social_instagram_24px"></icon></a>
                      <a href="https://www.linkedin.com/company/14598640" target="_blank"><icon icon="social_linkedin_24px"></icon></a>
                      <a href="https://twitter.com/joi_events" target="_blank"><icon icon="social_twitter_24px"></icon></a>
                      <a href="https://www.youtube.com/channel/UCwKgcz7M_R1YTtDAYWCf3tA" target="_blank"><icon icon="social_youtube_24px"></icon></a>
                  </div>
              </div>
              <!-- <ng-container [ngTemplateOutlet]="progress" [ngTemplateOutletContext]="{ main: false }"></ng-container> -->
              
              <div class="info">
                  <div>Version {{uiService.version}}</div>&nbsp;&bull;&nbsp;
                  <a class="underline" href="https://www.joi.events/eula" target="_blank" title="EULA">EULA</a>&nbsp;&bull;&nbsp;
                  <a class="underline" href="https://www.joi.events/privacy" target="_blank" title="Privacy Policy">Privacy Policy</a>
                  <div style="flex:1"></div>
                  <h5 class="sign-out" (click)="signOut()">Sign Out</h5>
              </div>
          </div>
      </div>
  </div>
  <menu-panel *ngIf="mobileView" [mobile]="true" (viewingNewPage)="closeMobileMenu($event)"></menu-panel>
  <div class="cloud" (click)="closeMobileMenu($event)"></div>
</div>
  


<ng-template #progress let-main="main">
  <div class="progress_bar desktop" [ngClass]="{ main: main }" *ngIf="!!event">
    <div class="filler" [ngStyle]="{ width: event.percentUsed + '%' }" [ngClass]="{ red: event.percentUsed > 90 }"></div>
    <div class="progress" (click)="main ? null : debugEvent()">{{ event.percentUsed }}% of event size used</div>
  </div>
</ng-template>